import { render, staticRenderFns } from "./TheSuccessAreaLink.vue?vue&type=template&id=045825fc&scoped=true"
import script from "./TheSuccessAreaLink.vue?vue&type=script&lang=js"
export * from "./TheSuccessAreaLink.vue?vue&type=script&lang=js"
import style0 from "./TheSuccessAreaLink.vue?vue&type=style&index=0&id=045825fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045825fc",
  null
  
)

export default component.exports